// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"245":"2477e492","332":"64c25a98","453":"53dcd7c0","494":"bf9bcf00","888":"cede0863","983":"20e11962"}[chunkId] + ".chunk.js";
};